export default "__VITE_ASSET__Dol4XU8Y__"